export const drumKit = [
  {
    name: "clap",
    key: "A",
    dataKey: "65",
    audio: require("@/assets/audio/clap.wav"),
    isPlaying: false
  },
  {
    name: "hihat",
    key: "S",
    dataKey: "83",
    audio: require("@/assets/audio/hihat.wav"),
    isPlaying: false
  },
  {
    name: "kick",
    key: "D",
    dataKey: "68",
    audio: require("@/assets/audio/kick.wav"),
    isPlaying: false
  },
  {
    name: "openhat",
    key: "F",
    dataKey: "70",
    audio: require("@/assets/audio/openhat.wav"),
    isPlaying: false
  },
  {
    name: "boom",
    key: "G",
    dataKey: "71",
    audio: require("@/assets/audio/boom.wav"),
    isPlaying: false
  },
  {
    name: "ride",
    key: "h",
    dataKey: "72",
    audio: require("@/assets/audio/ride.wav"),
    isPlaying: false
  },
  {
    name: "snare",
    key: "J",
    dataKey: "74",
    audio: require("@/assets/audio/snare.wav"),
    isPlaying: false
  },
  {
    name: "tom",
    key: "K",
    dataKey: "75",
    audio: require("@/assets/audio/tom.wav"),
    isPlaying: false
  },
  {
    name: "tink",
    key: "L",
    dataKey: "76",
    audio: require("@/assets/audio/tink.wav"),
    isPlaying: false
  }
];
